import { makeAutoObservable } from "mobx";
import { getCreateUser, getUserInfo } from "@/api/apiMethods.js";
import avatar1 from "@/assets/avatar/1.jpg";
import avatar2 from "@/assets/avatar/2.jpg";
import avatar3 from "@/assets/avatar/3.jpg";
import avatar4 from "@/assets/avatar/4.jpg";
import avatar5 from "@/assets/avatar/5.jpg";
import avatar6 from "@/assets/avatar/6.jpg";

class UserStore {
  user = null;
  point = 0;
  usdt = 0;
  credit = 0;
  avatar = null;
  constructor() {
    makeAutoObservable(this);
    // 在构造函数中尝试从 localStorage 加载用户数据
    this.loadUserFromLocalStorage();
  }

  // 从 localStorage 加载用户数据
  loadUserFromLocalStorage() {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      this.user = JSON.parse(storedUser); // 解析存储的 JSON 数据
    }
  }

  // 保存用户数据到 localStorage
  saveUserToLocalStorage() {
    if (this.user) {
      localStorage.setItem("user", JSON.stringify(this.user)); // 转换为 JSON 字符串并保存
    }
  }

  async fetchUserInfo(params) {
    try {
      const createUser = await getCreateUser(params);
      this.point = createUser.point;
      this.credit = createUser.credit;
      this.user = createUser;
      const avatarIndex = this.user.profile_photo - 1;
      const avatars = [avatar1, avatar2, avatar3, avatar4, avatar5, avatar6];
      this.avatar = avatars[avatarIndex];
      console.log(this.avatar, "this.avatar");
      // 保存用户信息到 localStorage
      this.saveUserToLocalStorage();
    } catch (error) {
      console.log(error);
    }
  }
  async getUserInfo() {
    try {
      if (this.user) {
        const getUser = await getUserInfo({ uid: this.user.id });
        console.log("getUser", getUser);
        this.point = getUser.point;
        this.credit = getUser.credit;
        this.user = getUser;
        const avatarIndex = this.user.profile_photo - 1;
        const avatars = [avatar1, avatar2, avatar3, avatar4, avatar5, avatar6];
        this.avatar = avatars[avatarIndex];
        console.log(avatars[avatarIndex], avatarIndex, avatars, "this.avatar");
        // 保存用户信息到 localStorage
        this.saveUserToLocalStorage();
      }
    } catch (error) {
      console.log(error);
    }
  }
  // 清除用户数据
  clearUser() {
    this.user = null;
    this.point = 0;
    this.credit = 0;
    localStorage.removeItem("user"); // 从 localStorage 移除用户数据
    console.log("thisaaa", this.user);
  }
  addPoint(val) {
    this.point += val;
  }
  addUsdt(val) {
    console.log("11this.usdt", this.usdt);
    this.usdt = (parseFloat(this.usdt) + parseFloat(val)).toFixed(2);
    console.log("this.usdt", this.usdt);
    console.log("val", val);
  }
  addCredit(val) {
    this.credit += val;
    console.log("1userthis.credit", this.credit, val);
  }
  subtractPoint(val) {
    this.point -= val;
  }

  subtractUsdt(val) {
    this.usdt = (parseFloat(this.usdt) - parseFloat(val)).toFixed(2);
  }

  subtractCredit(val) {
    this.credit -= val;
  }
}

const userStore = new UserStore();
export default userStore;
